import { render, staticRenderFns } from "./syCom.vue?vue&type=template&id=0e42643e&scoped=true"
import script from "./syCom.vue?vue&type=script&lang=js"
export * from "./syCom.vue?vue&type=script&lang=js"
import style0 from "./syCom.vue?vue&type=style&index=0&id=0e42643e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e42643e",
  null
  
)

export default component.exports